export default "__VITE_ASSET__282fe127__"